import React from "react";
import ChipSelect from "../../../../components/chipSelect";
import FieldLabel from "../../../../components/label";
import { withStyles } from "@mui/styles";
import { useStyles } from "../../indexFormStyles";
import { Box, TextField } from "@mui/material";

function AppointeeEmailDetails({
  classes: { borderBgColorContainer, formGroup },
  errorMessage,
  form,
  handleChange,
  handleChangeChipSelect,
  options,
}) {
  return (
    <Box className={borderBgColorContainer} p={1} mt={2}>
      <Box className={formGroup} pt={0}>
        <FieldLabel label={"Appointee Email Available*"} />
        <ChipSelect
          fieldname={"appointee_email_available"}
          handleChange={handleChangeChipSelect}
          options={options.availableOrNot}
          selectedItem={form.appointee_email_available}
          isMinWidth={true}
        />
      </Box>

      {form.appointee_email_available === "Available" && (
        <>
          <Box className={formGroup} pt={0} pb={0}>
            <FieldLabel label={"Email same as the Owner of the Policy*"} />
            <ChipSelect
              fieldname={"appointee_email_same_as_owner"}
              handleChange={handleChangeChipSelect}
              options={options.sameOrDifferent}
              selectedItem={form.appointee_email_same_as_owner}
              isMinWidth={true}
            />
          </Box>

          {form.appointee_email_same_as_owner === "Different" && (
            <Box className={formGroup} pt={0} pb={0}>
              <FieldLabel label={"Appointee Email*"} />
              <TextField
                id="standard-basic"
                variant="outlined"
                value={form.appointee_email}
                name="appointee_email"
                onChange={handleChange}
                autoComplete="off"
                helperText={errorMessage.appointee_email}
                fullWidth
              />
            </Box>
          )}
        </>
      )}
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(
  AppointeeEmailDetails
);
